import { SuperAdminCliClientsPage } from "../../operator/console/super-admin-cli-clients";

export default function ConsoleSuperAdminCliClients() {
  return <SuperAdminCliClientsPage />;
}
